var _circle, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgScrollToTop = function SvgScrollToTop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E0EAED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8702 34.6335L30 25.5037L39.1298 34.6335C39.3645 34.8682 39.6829 35 40.0148 35C40.3468 35 40.6651 34.8682 40.8999 34.6335L41.6335 33.8999C41.8682 33.6651 42 33.3468 42 33.0148C42 32.6829 41.8682 32.3645 41.6335 32.1298L30.8851 21.3814C30.6503 21.1467 30.3319 21.0148 30 21.0148C29.6681 21.0148 29.3497 21.1467 29.1149 21.3814L18.3665 32.1298C18.1318 32.3645 18 32.6829 18 33.0148C18 33.3468 18.1318 33.6651 18.3665 33.8999L19.1001 34.6335C19.3349 34.8682 19.6532 35 19.9852 35C20.3171 35 20.6355 34.8682 20.8702 34.6335Z",
    fill: "#1D588C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScrollToTop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scrollToTop.acd1ec5c.svg";
export { ForwardRef as ReactComponent };